// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pJmf","top":"styles_top__3KlJe","left":"styles_left__1J8gE","description":"styles_description__k_Y8t"};